<template>
  <div>
    <div class="fans-head">
      <div class="fans-head-con">
        <img src="../../img/touxiang.png" alt="" class="fans-tx">
        <div>
          <p class="fans-p">喧嚣上等...</p>
          <p class="fans-p1">个性签名：这个人很懒，什么也没留下</p>
        </div>
      </div>
    </div>
    <div class="fans-foot">
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="400">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    },
    data() {
      return {
        currentPage1: 5,
        currentPage2: 5,
        currentPage3: 5,
        currentPage4: 4
      };
    }
  }
</script>
<style>
  .el-pager li.active {
    color: #28A3B1;
  }
  .el-pager li:hover {
    color: #28A3B1;
  }
  .el-pagination{
    margin-top: 20px;
  }
</style>
<style>
  .fans-head {
    width: 900px;
    background-color: #fff;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #E6E6E6;
    border-radius: 6px;
  }

  .fans-foot {
    width: 900px;
    display: flex;
    justify-content: center;
    background-color: #F5F5F5;
  }
  .fans-head-con{
    width: 100%;
height: 70px;
box-sizing: border-box;
border-bottom:1px solid #E6E6E6;
display: flex;
  }
  .fans-tx{
    width: 40px;
    height: 40px;
    margin-right: 20px;
  }
  .fans-p{
    font-size: 14px;
  }
   .fans-p1{
    font-size: 14px;
    margin-top: 10px;
    width: 100%;
    overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/fans.vue